import { type Epic } from 'redux-observable';
import { filter } from 'rxjs';
import { request } from '@/core';
import { deleteIncidentRequest } from '@/api/events';
import { deleteIncident } from '../actions';

const deleteIncidentEpic: Epic = (action$) =>
  action$.pipe(
    filter(deleteIncident.match),
    request(({ payload }) => deleteIncidentRequest(payload), deleteIncident),
  );

export default deleteIncidentEpic;
